module.exports = __webpack_public_path__ + "img/1.dc2acc72.jpg";